import _ from 'lodash';

export default _.debounce(() => {
    const screenWidth = window.innerWidth;
    const consentUi = document.getElementById('consentui');
    
    const header =  document.getElementById('header');
    const navBar = document.getElementById('navbar');
    const filter = document.getElementById('filter');
    const vendorListContainer = document.getElementById('vendorlist__container');
    const vendorList = document.getElementById('vendorlist');
    const vendorlistInformation = document.getElementById('vendorlistInformation');
    const buttons =  document.getElementById('buttons');

    if (screenWidth > 500 && consentUi && header && navBar && vendorListContainer && buttons && vendorList && vendorlistInformation) {
        const height = consentUi.offsetHeight - header.offsetHeight - navBar.offsetHeight - buttons.offsetHeight;

        if (filter.style.height !== height+'px') filter.style.height = height +'px';
        if (vendorListContainer.style.height !== height+'px') vendorListContainer.style.height = height+'px';
        if (vendorList.style.height !== height - vendorlistInformation.offsetHeight+'px') vendorList.style.height = height - vendorlistInformation.offsetHeight+'px';
    } else if (consentUi && header && navBar && buttons && vendorList && vendorlistInformation) {
        const height = consentUi.offsetHeight - header.offsetHeight - navBar.offsetHeight - buttons.offsetHeight - filter.offsetHeight;

        if (vendorList.style.height !== height - vendorlistInformation.offsetHeight+'px') vendorList.style.height = height - vendorlistInformation.offsetHeight+'px';  
    }
    
}, 150);
